import { GenericMenuComponent } from "../generic-menu-component.model";
export class MenuComponent extends GenericMenuComponent {
    constructor() {
        super(...arguments);
        this.items = [];
    }
}
